import FileViewer from "react-file-viewer";

const DocViewerComponent = (props) => {
  return <FileViewer fileType={"docx"} filePath={props.title} />;
};

export default DocViewerComponent;
